import { NavLink } from 'react-router-dom';

const items = [
  { to: '/', label: 'หน้าหลัก', icon: '🏠' },
  { to: '/history', label: 'ประวัติ', icon: '📋' },
  { to: '/profile', label: 'โปรไฟล์', icon: '👤' },
];

export function BottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-gray-200 bg-white pb-[env(safe-area-inset-bottom)]">
      <ul className="mx-auto grid max-w-md grid-cols-3">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              end={it.to === '/'}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2 text-xs ${
                  isActive ? 'text-line' : 'text-gray-500'
                }`
              }
            >
              <span className="text-xl leading-none">{it.icon}</span>
              <span>{it.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
